import type { UsFdaSubmissions } from '../types';

/** The US_FDA product's current label (`fda_label_supplements.id`), read from
 *  `GET /drugs/{us_fda_id}/us_fda_submissions`; null when no label is current.
 *  Resolved by the US_FDA identity — `/drugs/{id}/fda_label_pdf_docs` matches the
 *  legacy `drug_id` and finds nothing for a US_FDA product. */
export function currentUsFdaLabelId(subs: UsFdaSubmissions | null | undefined): number | null {
  for (const s of subs?.submissions ?? []) {
    if (s.label?.is_current) return s.label.document_id;
  }
  return null;
}
